import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image5 from "../../../../assets/images/Blog51/image5.png";
import image114 from "../../../../assets/images/Blog51/image114.png";
import image147 from "../../../../assets/images/Blog51/image147.png";
import image9 from "../../../../assets/images/Blog51/image9.png";
import image10 from "../../../../assets/images/Blog51/image10.png";
import image12 from "../../../../assets/images/Blog51/image12.png";
import image14 from "../../../../assets/images/Blog51/image14.png";
import image17 from "../../../../assets/images/Blog51/image17.png";
import image31 from "../../../../assets/images/Blog51/image31.png";
import image140 from "../../../../assets/images/Blog51/image140.png";
import image1 from "../../../../assets/images/Blog51/image1.png";
import image100 from "../../../../assets/images/Blog51/image100.png";
import image103 from "../../../../assets/images/Blog51/image103.png";
import image28 from "../../../../assets/images/Blog51/image28.png";
import image135 from "../../../../assets/images/Blog51/image135.png";
import image90 from "../../../../assets/images/Blog51/image90.png";
import image92 from "../../../../assets/images/Blog51/image92.png";
import image129 from "../../../../assets/images/Blog51/image129.png";
import image66 from "../../../../assets/images/Blog51/image66.png";
import image68 from "../../../../assets/images/Blog51/image68.png";
import image87 from "../../../../assets/images/Blog51/image87.png";
import image88 from "../../../../assets/images/Blog51/image88.png";
import image81 from "../../../../assets/images/Blog51/image81.png";
import image151 from "../../../../assets/images/Blog51/image151.png";
import image67 from "../../../../assets/images/Blog51/image67.png";

const Blog51 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – January 12th, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Breadth Expands, Growth Persists, Volatility Remains Dormant</p>
        <p>
          Markets continue to lean on structure rather than momentum as the year settles into its first full trading rhythm. The past week reinforced a tone of stability, with participation quietly
          improving beneath the surface even as headline indices paused rather than pushed higher. Liquidity remains available, and once again, the absence of forced selling proved more influential
          than any individual data point.
        </p>
        <p>
          At the same time, calm should not be mistaken for conviction. Volatility remains compressed across asset classes, sentiment has improved from late-year caution, and expectations are
          beginning to rise. This creates a constructive but delicate backdrop—one where markets are increasingly sensitive to disappointment rather than insulated from it.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Rotation Over Acceleration</p>
              <p>
                Equity markets remain supported, with trend structure intact and internal participation broadening. This has not been a momentum-driven surge or a valuation-led expansion. Instead, the
                market is redistributing leadership, rotating away from narrow concentration and toward smaller caps and equal-weight exposure.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="week one small cap party."
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This shift suggests engagement is widening rather than intensifying. The S&P 500 continues to trade comfortably above its longer-term moving averages, reinforcing the view that the
                broader trend remains functional even as upside momentum moderates.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image114}
                    alt="SPX 200dma above % bullish&healthy"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image114)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Breadth data adds weight to this interpretation. A growing share of constituents remain above short-, medium-, and long-term averages, indicating that price action is being supported
                by participation across the index rather than carried by a shrinking group of leaders.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image147}
                    alt="SPX breadth solid"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image147)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                At the macro level, growth continues to provide the underlying cushion. Services activity remains the dominant driver, offsetting softness elsewhere and keeping real-time growth
                estimates elevated.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="US Services leading the growth surge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Growth Holds as Policy Stays Active</p>
              <p>
                Macro data over the week reinforced resilience rather than reacceleration. Real-time GDP tracking moved sharply higher, driven primarily by services and consumption, even as
                housing-related investment remained a drag on the overall picture.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="Atlanta GDPNow boom"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="resi spend pulling GDP down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The labour market continues to reflect adjustment rather than deterioration. Job openings declined, but layoffs remained contained, while quits increased—suggesting mobility and churn
                rather than stress or contraction.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="JOLTS by industry"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=" QUITS up a positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Policy framing remains broadly accommodative. Rate expectations continue to align with rules-based frameworks, pointing toward lower policy settings over time, even as near-term cuts
                are repriced out of the immediate horizon.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt="Taylor Rule says lower rates in US"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image140}
                    alt="Jan Fed cut almost gon"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image140)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Alongside growth and rates, resources remain a recurring macro anchor. Control of supply chains, energy flows, and strategic commodities continues to intersect with inflation dynamics
                and broader policy considerations.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="Donroe Doctrine explained"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                From a technical perspective, the structure remains intact. Major indices continue to respect trend channels and key moving averages, with pullbacks remaining contained and corrective
                rather than impulsive.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image100}
                    alt="SPX GFC uptrend channel"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image100)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image103}
                    alt="SPX above 50dma healthy"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image103)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Momentum, however, has slowed meaningfully. This is visible not through breakdowns, but through consolidation near highs and increasing dispersion beneath the index surface. Leadership
                churn has replaced directional thrust.
              </p>
              <p>
                Sentiment reflects this balance. Indicators have improved from late-year caution but remain closer to neutral than exuberant. Historically, this zone tends to leave markets more
                reactive to shocks than resilient to them.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt="4m high for sentiment"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image135}
                    alt=" Fear & greed neutral"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image135)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Volatility remains deeply suppressed across both equity and rates markets. While this has supported drift and carry strategies, dispersion suggests that risk is being stored internally
                rather than expressed outright.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image90}
                    alt="vix1D suppressed"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image90)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image92}
                    alt="Dispersion increasing risks higher VIX"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image92)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Growth Holds, Volatility Stays Compressed</p>
              <p>
                Markets moved through the week with little visible stress, even as participation improved and expectations edged higher. Data generally supported growth, while positioning and flows
                continued to matter more than conviction. Beneath the calm, however, several familiar fault lines remained unresolved.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Growth data surprised positively, led by services activity and real-time GDP tracking. Housing and manufacturing remained uneven, but the absence of forced selling or rate
                    stress allowed equities to maintain structure. Liquidity continued to cushion downside rather than accelerate upside.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image9}
                        alt="US Services leading the growth surge."
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image9)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>China remained relevant primarily through commodity and trade channels rather than headline macro releases. Demand dynamics continued to influence metals and industrial
                    inputs, reinforcing China’s role as a marginal driver rather than a directional catalyst.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image129}
                        alt="China retail healthy"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image129)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Earnings remained the underlying anchor for equities. Profit trends continued to support market structure, even as leadership rotated and valuation dispersion widened
                    beneath the surface.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image114}
                        alt="SPX 200dma above % bullish&healthy"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image114)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Hard assets continued to attract attention, supported by flow dynamics and re-weighting effects. Price action remained constructive, but positioning suggests sensitivity
                    to sentiment shifts rather than speculative excess.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image66}
                      alt="hard assets longs everywhere"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image66)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image68}
                      alt="BB reweight numbers"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image68)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>The crypto price action resembled consolidation rather than a reversal. Valuation support held, but positioning remained heavy, keeping conviction contained and volatility
                    muted.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image87}
                      alt="BTC valuation model1"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image87)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image88}
                      alt="bitcoin valuation model 2"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image88)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy markets remained capped by sentiment despite ongoing geopolitical relevance. Positioning stayed relatively negative, leaving oil responsive to flow changes rather
                    than fundamentals alone.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image81}
                        alt="oil positioning neutral going into 2026"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image81)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                With liquidity largely restored, the coming week brings a dense and globally relevant run of macro data. U.S. CPI on Tuesday and PPI on Wednesday sit firmly at the centre of the
                calendar, while UK GDP, bank earnings, and Asia-Pacific data feature prominently across growth, inflation, and activity trends. With positioning elevated and volatility compressed, how
                markets react to confirmation or disappointment may matter more than the releases themselves.
              </p>
              <p className="highlightedText">Monday, January 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Market Holiday (Coming of Age Day)
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe:</span> Sentix Investor Confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe:</span> German Current Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Employment Trends Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Treasury Auctions (3Y, 10Y)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, January 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand: </span> Business Confidence, Capacity Utilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Consumer Sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Current Account, Bank Lending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> BRC Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> CPI (Headline & Core)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Real Earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> NFIB Small Business Optimism
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> JPMorgan Earnings
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, January 14</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Trade Balance, Exports, Imports
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Credit Data (Loans, TSF, M2)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Machine Tool Orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PPI (Headline & Core)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Existing Home Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Bank of America, Wells Fargo, Citi Earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Supreme Court Opinion on Tariffs (Tentative)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, January 15</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">South Korea:</span> Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> GDP, Industrial & Manufacturing Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> CPI (France, Spain, Italy)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Regional Manufacturing Surveys
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> BlackRock, Morgan Stanley, Goldman Sachs Earnings
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, January 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand:</span> PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe:</span> German & Italian CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Capacity Utilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> NAHB Housing Market Index
                  </p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image151}
                  alt="EW 120126"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image151)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Constructive Structure, Rising Sensitivity</p>
              <p>
                Markets remain supported, but not comfortable. Structure and liquidity continue to do the heavy lifting for risk assets, while confidence in prevailing narratives is being tested
                rather than reinforced. Price action remains orderly, but the margin for error is narrowing as expectations rise.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Broadening participation continues to support the trend, but leadership rotation suggests upside is becoming increasingly selective rather than broad-based. This remains a
                    market that rewards positioning and patience rather than indiscriminate exposure.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Hard assets remain supported by structural and flow-driven dynamics. While positioning may introduce near-term
                    volatility, the underlying bid remains intact, particularly as confidence in long-duration assets remains uneven.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Price action continues to resemble consolidation rather than reversal. Valuation support is present, but conviction
                    remains uneven, suggesting the market is still working through positioning rather than attracting fresh directional flow.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Growth remains resilient, policy remains active, and volatility remains compressed. This combination continues to favour
                    engagement, but also leaves markets increasingly sensitive to disappointment when expectations are elevated.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">This still feels like a grind higher—until it doesn’t. Flows decide direction, but crowded trades tend to unwind quietly before they unwind abruptly.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image147}
                    alt="SPX breadth solid"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image147)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image90}
                    alt="vix1D suppressed"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image90)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image67}
                    alt="yardeni gold uptrend"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image67)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1l5klVRYvLnoPCUadsofRAVMySgt3Ktw8KvJkLZvP2QI/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog51;
